import React, { Suspense, useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';

const LazyRender = ({ children, height = '350px', id }) => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.7 });
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (inView) {
      setIsVisible(true);
    }
  }, [inView]);

  return (
    <div ref={ref} id={id} style={{ minHeight: height }}>
      {isVisible ? (
        <Suspense fallback={<div style={{ minHeight: height }} />}>
          {children}
        </Suspense>
      ) : (
        <div style={{ minHeight: height }} />
      )}
    </div>
  );
};

export default LazyRender;
